import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import { IIssuesObservationTableData } from './type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getIssuesObservationTableData = async () => {
	const resp = await apiWrapper.get<
		IIssuesObservationTableData[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-issues`);

	return resp;
};
